import React from "react";

const PROXY = "https://corsproxy.io/?";
const WMS_URL = "https://mute-queen-37fegeoserver-proxy.morelstevensndong.workers.dev";
const url = `${PROXY}${WMS_URL}?service=WMS&version=1.1.1&request=GetCapabilities`;

export default function LegendPanel({ layer }) {
  if (!layer) return null;
  const legendUrl = `${PROXY}${WMS_URL}?service=WMS&request=GetLegendGraphic&format=image/png&layer=${layer}`;
  return (
    <div className="legend-panel">
      <img src={legendUrl} alt={`Légende ${layer}`} />
    </div>
  );
}
